import { useState } from "react";

const Admin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("email_inquiry");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const adminCredentials = {
      username: "admin@visaworld",
      password: "visaworld@124",
    };

    if (
      username !== adminCredentials.username &&
      password !== adminCredentials.password
    ) {
      setError("Invalid username or password.");
    } else if (username !== adminCredentials.username) {
      setError("Invalid username.");
    } else if (password !== adminCredentials.password) {
      setError("Invalid password.");
    } else {
      setIsAuthenticated(true);
      fetchEmailInquiry();
    }
  };

  const fetchEmailInquiry = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://visaworlds.net/api/getData.php");
      const data = await res.json();
      setRecords(data);
      setActiveTab("email_inquiry");
    } catch (error) {
      console.error("Error fetching email inquiry data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col mt-32 items-center justify-center min-h-screen bg-gradient-to-br bg-[#FBF9FE] to-[#011473]">
      {!isAuthenticated ? (
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full">
          <h2 className="text-3xl font-bold text-center text-blue-500 mb-6">
            Admin Login
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="mt-1 p-3 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 p-3 w-full border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            {error && (
              <p className="text-red-600 text-sm text-center">{error}</p>
            )}
            <div className="flex items-center justify-between mt-6">
              <button
                type="submit"
                className="w-full bg-blue-500 hover:text-black hover:font-semibold text-white py-3 rounded-lg hover:bg-blue-600 transition duration-300 ease-in-out"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="bg-white w-full max-w-9xl mt-5">
          <h2 className="text-3xl font-bold text-center text-gray-800 py-6">
            Admin Panel
          </h2>
          <div className="flex justify-center mb-6">
            <button
              onClick={fetchEmailInquiry}
              className={`px-4 py-2 rounded-lg mx-2 ${
                activeTab === "email_inquiry"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700"
              }`}
            >
              Email Inquiry
            </button>
          </div>
          {loading ? (
            <div className="flex justify-center py-10">
              <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-32 w-32"></div>
            </div>
          ) : (
            <div className="overflow-x-auto px-3">
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr className="bg-slate-50 text-gray-600 font-inter text-base leading-normal border-2">
                    <th className="py-3 px-6 text-left">No.</th>
                    <th className="py-3 px-6 text-left">First Name</th>
                    <th className="py-3 px-6 text-left">Last Name</th>
                    <th className="py-3 px-6 text-left">Email</th>
                    <th className="py-3 px-6 text-left">Marital Status</th>
                    <th className="py-3 px-6 text-left">Nationality</th>
                    <th className="py-3 px-6 text-left">Occupation</th>
                    <th className="py-3 px-6 text-left">Destination Country</th>
                    <th className="py-3 px-6 text-left">Message</th>
                    <th className="py-3 px-6 text-left">Date</th>
                  </tr>
                </thead>
                <tbody className="text-gray-600 text-sm font-light">
                  {records.length > 0 ? (
                    records.map((record, index) => (
                      <tr
                        key={index}
                        className="border-b border-gray-200 hover:bg-gray-100"
                      >
                        <td className="py-3 px-6">{index + 1}</td>
                        <td className="py-3 px-6">{record.firstName}</td>
                        <td className="py-3 px-6">{record.lastName}</td>
                        <td className="py-3 px-6">{record.email}</td>
                        <td className="py-3 px-6">{record.maritalStatus}</td>
                        <td className="py-3 px-6">{record.nationality}</td>
                        <td className="py-3 px-6">{record.occupation}</td>
                        <td className="py-3 px-6">{record.destinationCountry}</td>
                        <td className="py-3 px-6">{record.message}</td>
                        <td className="py-3 px-6">
                              {new Date(record.datetime).toLocaleString()}
                            </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="9"
                        className="py-3 px-6 text-center text-gray-500"
                      >
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              
            </div>
          )}
          <div className="flex justify-center items-center py-12">
            <button
              onClick={() => setIsAuthenticated(false)}
              className="bg-blue-500 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300 ease-in-out"
            >
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
